import { render, staticRenderFns } from "./index2.vue?vue&type=template&id=e9c487cc&scoped=true&"
import script from "./index2.vue?vue&type=script&lang=js&"
export * from "./index2.vue?vue&type=script&lang=js&"
import style0 from "./index2.vue?vue&type=style&index=0&id=e9c487cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c487cc",
  null
  
)

export default component.exports